import axios from "./axiosinstance";

const TestCaseApi = {
  /* =========================================
     CREATE
  ========================================= */

  create: (payload) =>
    axios.post(
      "/test-cases",
      payload
    ),


  /* =========================================
     GET PROJECT TEST CASES
  ========================================= */

  getProjectTestCases: (projectId) =>
    axios.get(
      `/test-cases/project/${projectId}`
    ),


  /* =========================================
     GET SINGLE TEST CASE
  ========================================= */

  details: (id) =>
    axios.get(
      `/test-cases/${id}`
    ),


  /* =========================================
     UPDATE TEST CASE
  ========================================= */

  update: (id, payload) =>
    axios.put(
      `/test-cases/${id}`,
      payload
    ),


  /* =========================================
     UPDATE TEST CASE STATUS
  ========================================= */

  updateStatus: (id, payload) =>
    axios.put(
      `/test-cases/${id}/status`,
      payload
    ),


  /* =========================================
     DELETE TEST CASE
  ========================================= */

  delete: (id) =>
    axios.delete(
      `/test-cases/${id}`
    ),


  /* =========================================
     SUPERADMIN TEST CASE SUMMARY
  ========================================= */

  getSuperadminSummary: () =>
    axios.get(
      "/test-cases/superadmin/summary"
    ),
};


export default TestCaseApi;